import React, { useState, useEffect } from 'react';

const VoiceCommand = ({ onCommand }) => {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState('');
  const [recognition, setRecognition] = useState(null);
  const [processingCommand, setProcessingCommand] = useState(false);

  useEffect(() => {
    if ('webkitSpeechRecognition' in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = true;

      recognition.onstart = () => {
        setIsListening(true);
        setTranscript('');
        setProcessingCommand(false);
      };

      recognition.onresult = (event) => {
        const transcript = Array.from(event.results)
          .map(result => result[0])
          .map(result => result.transcript)
          .join('');
        
        setTranscript(transcript);
        
        if (event.results[0].isFinal) {
          setProcessingCommand(true);
          setIsListening(false);
          onCommand(transcript);
        }
      };

      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        setIsListening(false);
        setProcessingCommand(false);
      };

      recognition.onend = () => {
        setIsListening(false);
      };

      setRecognition(recognition);
    }
  }, [onCommand]);

  const startListening = () => {
    if (recognition) {
      recognition.start();
    } else {
      alert('Speech recognition is not supported in your browser.');
    }
  };

  const stopListening = () => {
    if (recognition) {
      recognition.stop();
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4 p-4 bg-xkid-gray rounded-lg border border-xkid-green">
      <div className="text-center">
        <h2 className="text-xl font-bold text-xkid-green mb-2">Voice Commands</h2>
        <p className="text-gray-400 text-sm">
          Click the microphone and speak your question
        </p>
      </div>

      <button
        onClick={isListening ? stopListening : startListening}
        disabled={processingCommand}
        className={`p-4 rounded-full transition-all transform hover:scale-110 ${
          isListening
            ? 'bg-xkid-red animate-pulse'
            : processingCommand
            ? 'bg-xkid-green-dark opacity-50'
            : 'bg-xkid-green'
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
          />
        </svg>
      </button>

      {isListening && (
        <div className="text-center animate-pulse">
          <p className="text-xkid-green">Listening...</p>
          {transcript && (
            <p className="text-sm text-gray-400 mt-2">"{transcript}"</p>
          )}
        </div>
      )}

      {processingCommand && (
        <div className="text-center">
          <p className="text-xkid-green">Processing command...</p>
          <p className="text-sm text-gray-400 mt-2">"{transcript}"</p>
        </div>
      )}

      <div className="text-sm text-gray-400 mt-4">
        <h3 className="font-bold mb-2">Example Commands:</h3>
        <ul className="list-disc list-inside">
          <li>"Tell me about Minecraft"</li>
          <li>"How do I improve at Fortnite?"</li>
          <li>"What are the best weapons in Call of Duty?"</li>
          <li>"Give me tips for League of Legends"</li>
          <li>"What's new in Valorant?"</li>
        </ul>
      </div>
    </div>
  );
};

export default VoiceCommand; 